import { render, staticRenderFns } from "./IncreaseNumber.vue?vue&type=template&id=cdbc7d7c&"
import script from "./IncreaseNumber.vue?vue&type=script&lang=js&"
export * from "./IncreaseNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cdbc7d7c')) {
      api.createRecord('cdbc7d7c', component.options)
    } else {
      api.reload('cdbc7d7c', component.options)
    }
    module.hot.accept("./IncreaseNumber.vue?vue&type=template&id=cdbc7d7c&", function () {
      api.rerender('cdbc7d7c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2m5Qwtv0T70tC/JS/comp/IncreaseNumber.vue"
export default component.exports